// Whether the workspace offers "Not applicable" (architect Q5 as corrected,
// 2026-10-17, ARCHITECT_DECISION_ORDER_Q5_0021 171026.md Q1).
//
// The database refuses N/A on an `na_prohibited` criterion, and on an
// artifact that contains one (0022). The workspace does not offer what the
// database will refuse. `mandatory` permits N/A with rationale.

/** False if any of the given applicability rules forbids "Not applicable". */
export function offersNotApplicable(rules: Array<string | null>): boolean {
  return !rules.some((r) => r === "na_prohibited");
}
